"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const constants = __importStar(require("@/common/constants"));
const AppButton_vue_1 = __importDefault(require("@/client/components/common/AppButton.vue"));
const vueRoot_1 = require("@/client/components/vueRoot");
const paths_1 = require("@/common/app/paths");
exports.default = (0, vue_1.defineComponent)({
    name: 'LoadGameForm',
    components: {
        AppButton: AppButton_vue_1.default,
    },
    data() {
        return {
            gameId: undefined,
            rollbackCount: 0,
        };
    },
    methods: {
        loadGame() {
            const gameId = this.gameId;
            const rollbackCount = this.rollbackCount;
            if (gameId === undefined) {
                alert('Specify a game id');
                return;
            }
            const loadGameForm = {
                gameId,
                rollbackCount,
            };
            fetch(paths_1.paths.LOAD_GAME, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(loadGameForm),
            })
                .then((resp) => {
                if (!resp.ok) {
                    throw new Error(`Error getting game data: ${resp.statusText}`);
                }
                return resp.json();
            })
                .then((response) => {
                if (response.players.length === 1) {
                    window.location.href = 'player?id=' + response.players[0].id;
                    return;
                }
                else {
                    window.history.replaceState(response, `${constants.APP_NAME} - Game`, 'game?id=' + response.id);
                    (0, vueRoot_1.vueRoot)(this).game = response;
                    (0, vueRoot_1.vueRoot)(this).screen = 'game-home';
                }
            })
                .catch((err) => {
                alert('Error loading game');
                console.error(err);
            });
        },
    },
    computed: {
        APP_NAME() {
            return constants.APP_NAME;
        },
    },
});
